const product = JSON.parse(
  document.getElementById("productJsonScript").innerHTML
);

const productForm = document.querySelector(
  ".section_product .product-form"
);
const addToCartButtons = productForm.querySelectorAll(
  "button[type='submit']"
);
const productHandle = product.handle;
const productPrice = document.getElementById("productPrice-new");
const productCompareAtPrice = document.getElementById("productCompareAtPrice");
const variants = product.variants;

const setupListeners = () => {
  const variantOptions = document.querySelectorAll(
    ".variant-option input[type='radio']"
  );
  variantOptions.forEach((radio) => {
    radio.addEventListener("change", () => {
      const selectedOptions = Array.from(productForm.querySelectorAll(".variant-option input[type='radio']:checked"), (variant) => variant.value);

      // Find matching variant
      const matchedVariant = variants.find((variant) => {
        return selectedOptions.every((option) =>
          variant.options.includes(option)
        );
      });

      document.dispatchEvent(new CustomEvent("variant:changed", {
        "detail": matchedVariant
      }))

      if (matchedVariant.available) {
        addToCartButtons.forEach((button) => {
          button.classList.remove("is--disabled");
        })
      } else {
        addToCartButtons.forEach((button) => {
          button.classList.add("is--disabled");
        })
      }

      // Change product form variant id
      const productFormInput = document.querySelector(
        ".product-form input[name='id']"
      );
      productFormInput.value = matchedVariant.id;

      // Change URL
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', matchedVariant.id);
      variantUrl.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', variantUrl);

      // Change prices
      productPrice.textContent = formatMoney(
        matchedVariant.price,
        project.moneyFormat
      );
      productCompareAtPrice.textContent = formatMoney(
        matchedVariant.compare_at_price,
        project.moneyFormat
      );

      // Hide compare at price if it's not relevant
      matchedVariant.compare_at_price > matchedVariant.price
        ? productCompareAtPrice.classList.remove("hide")
        : productCompareAtPrice.classList.add("hide");

      updateVariantStatuses();
    });
  });
}

setupListeners();


function updateVariantStatuses() {
  const selectedOptionOneVariants = variants.filter(
    (variant) =>
      productForm.querySelector(
        'input[type="radio"]:checked'
      ).value === variant.option1
  );

  const inputWrappers = productForm.querySelectorAll(".variant-opions");

  inputWrappers.forEach((option, index) => {
    if (index === 0) return;

    const optionInputs = [...option.querySelectorAll('input[type="radio"]')];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available &&
          variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);

    setInputAvailability(optionInputs, availableOptionInputsValue);
  });
}

function setInputAvailability(elementList, availableValuesList) {
  elementList.forEach((element) => {
    const value = element.getAttribute("value");
    const availableElement = availableValuesList.includes(value);

    element.parentNode.classList.toggle("is--disabled", !availableElement);
  });
}

productForm.addEventListener("submit", async (event) => {
  event.preventDefault();

  addToCartButtons.forEach((button) => {
    button.querySelector(".button_loader").classList.remove("hide");
    button.setAttribute("disabled", true);
  });
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js?sections=mini-cart", {
      method: "POST",
      body: new FormData(productForm),
    });

    if (!response.ok) {
      throw new Error("Failed to add item to cart");
    }

    const data = await response.json();
    await updateMiniCart(data.sections["mini-cart"]);
    openMiniCart();
    updateCartCount(data.item_count);

    addToCartButtons.forEach((button) => {
      button.querySelector(".button_loader").classList.add("hide");
      button.removeAttribute("disabled");
    });

  } catch (error) {
    console.error("Error adding item to cart:", error);
  }
});
